/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { createContext } from 'react';

export interface DisablednessContext {
  disabled: boolean;
  setDisabled: (isDisabled: boolean) => void;
}

const initialValue = {
  disabled: false,
  setDisabled: () => {
    throw new Error('Cannot call setDisabled outside of DisablednessProvider');
  },
};

export const DisablednessContext = createContext<DisablednessContext>(initialValue);
